import styled from "styled-components";
import {
  flexEnd,
  multipleLineTextEllipse,
  scrollCss,
} from "../../styles/reUsableStyles";

export const TableContainer = styled.div<{ $maxHeight?: string }>`
  overflow-y: auto;
  width: 100%;
  border: 1px solid #f1effb;
  border-radius: 10px;
  /* max-height: ${({ $maxHeight }) => $maxHeight || "auto"}; */
  ${scrollCss}
`;

export const TableStyled = styled.table`
  width: 100%;
  border-collapse: collapse;
  table-layout: auto;
`;
export const TableHead = styled.thead<{ $bgColor?: string }>`
  color: ${({ theme }) => theme.colors.accent};
  background: ${({ theme, $bgColor }) => $bgColor || theme.colors.light.white};
  position: sticky;
  top: 0px;
  z-index: 5;
`;
export const TableBody = styled.tbody`
  color: ${({ theme }) => theme.colors.dark.neutral_450};

  position: relative;
`;

export const TableRow = styled.tr<{
  $bgColor?: string;
  $evenRowBgColor?: string;
  $headingBgColor?: string;
}>`
  &.row-clickable {
    cursor: pointer;
    /* border-bottom: 1px solid gray; */
    /* &:hover {
      background: ${({ theme }) => theme.colors.dark.neutral_450};
    } */
  }
  &:nth-child(odd) {
    background-color: white;
  }

  &:nth-child(even) {
    background: ${({ theme, $evenRowBgColor }) =>
      $evenRowBgColor || theme.colors.highlight};
  }

  &.header {
    background-color: ${({ $headingBgColor }) => $headingBgColor || "#f9f9fd"};
    border-bottom: 2px solid #e3dff6;
  }
`;
export const TableDataCell = styled.td`
  padding: 5px 10px;
  text-align: left;
  border-bottom: 1px solid #e3dff6;
  height: 70px;

  vertical-align: middle;
  &:last-child.actions {
    text-align: right;
  }
`;
export const TableHeadCell = styled.th`
  padding: 12px 10px;
  text-align: left;

  &:last-child.actions {
    text-align: right;
  }
`;

export const TableFooter = styled.tfoot``;

export const HeaderTitleWrapper = styled.div`
  white-space: nowrap;

  & .menu-icon {
    height: 12px;
    width: 12px;
    position: relative;
    top: 1px;
  }
`;

export const LoadingStyled = styled.div`
  position: absolute;
  left: 0px;
  right: 0px;
  top: 0px;
  bottom: 0px;
  display: flex;
  align-items: center;
  justify-content: center;

  z-index: ${({ theme }) => theme.zIndices.auto};
  background: rgba(200, 200, 200, 0.4);
`;

export const NodataStyled = styled.div`
  height: 50vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TableCardViewContainer = styled.div`
  margin: 20px 0px;
  width: 100%;
  background: ${({ theme }) => theme.colors.light.white};
`;

export const IndividualTableRow = styled.div`
  background: ${({ theme }) => theme.colors.light.white};
  border-radius: 6px;
  padding: 18px 24px;

  & + & {
    margin-top: 20px;
  }
`;

export const TableCardRow = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
  & .heading {
    flex-shrink: 0;
  }
  & .ellipsis {
    ${multipleLineTextEllipse(2)}
  }

  & + & {
    margin-top: 6px;
  }

  &.actions {
    ${flexEnd(12)};
  }
`;
